const locale = window.navigator.language || 'en'

const eventTimeOptions = {
  hour: 'numeric',
  minute: 'numeric'
}

const eventDateOptions = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric'
}

export const localEventTime = datetime => {
  return new Date(datetime).toLocaleTimeString(locale, eventTimeOptions)
}

export const localEventDate = datetime => {
  return new Date(datetime).toLocaleDateString(locale, eventDateOptions)
}